import React from 'react'
import { Modal } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'

function CancelAllModal(props) {
  const handleCancelItem = () => {
    props.handleCancelItem()
    props.onHide()
  }
  return (
    <Modal {...props} className="cancel-modal-container" centered>
      <Modal.Header closeButton data-testid="qa-subscription-cancel-items">
        <Modal.Title className="cancelmodal-question">
          {i18nTranslate(
            'subscription.cancelAllQuestion',
            'Are you sure you want to cancel all of your subscription items?'
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="cancelmodal-description">
          {i18nTranslate(
            'subscription.cancelAllDescription',
            'Your Nu Skin Rewards eligibility may be affected by making this change.'
          )}
        </div>
        <div className="cancelmodal-button-container">
          <button
            className="cancelmodal-button-back"
            data-testid="qa-subscriptions-keep-subscriptions"
            onClick={props.onHide}>
            {i18nTranslate(
              'subscription.cancelAllBackButton',
              'Nevermind, keep my subscriptions'
            )}
          </button>
          <button
            className="cancelmodal-button-continue"
            data-testid="qa-subscription-cancel-all-items"
            onClick={handleCancelItem}>
            {i18nTranslate(
              'subscription.cancelAllConfirmButton',
              'Yes, cancel all subscriptions'
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export { CancelAllModal }
